(function () {
  'use strict';

  var data = window.ExclusiveRingsReviewData;
  var grid = document.getElementById('erReviewsGrid');
  if (!data || !grid) return;

  var search = document.getElementById('erReviewsSearch');
  var rating = document.getElementById('erReviewsRating');
  var sort = document.getElementById('erReviewsSort');
  var clear = document.getElementById('erReviewsClear');
  var status = document.getElementById('erReviewsStatus');
  var empty = document.getElementById('erReviewsEmpty');
  var loadMore = document.getElementById('erReviewsLoadMore');
  var average = document.getElementById('erReviewsAverage');
  var total = document.getElementById('erReviewsTotal');
  var pageSize = 12;
  var visible = pageSize;

  average.textContent = data.average.toFixed(1) + '/5';
  total.textContent = 'from ' + data.total.toLocaleString() + ' verified customer reviews';

  function element(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (typeof text === 'string') node.textContent = text;
    return node;
  }

  function normalized(value) {
    return (value || '').toLowerCase().replace(/\s+/g, ' ').trim();
  }

  function dateLabel(value) {
    var parsed = new Date(value);
    if (isNaN(parsed.getTime())) return '';
    return parsed.toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' });
  }

  function stars(reviewRating) {
    var wrapper = element('span', 'er-review-stars');
    wrapper.setAttribute('role', 'img');
    wrapper.setAttribute('aria-label', reviewRating + ' out of 5 stars');
    wrapper.textContent = '★★★★★'.slice(0, reviewRating) + '☆☆☆☆☆'.slice(0, 5 - reviewRating);
    return wrapper;
  }

  function reviewCard(review) {
    var card = element('article', 'er-review-card');
    card.setAttribute('data-review-id', review.id);

    var top = element('div', 'er-review-card-top');
    top.appendChild(stars(review.rating));
    var time = element('time', 'er-review-date', dateLabel(review.date));
    time.dateTime = review.date;
    top.appendChild(time);
    card.appendChild(top);

    card.appendChild(element('h2', 'er-review-title', review.title));
    card.appendChild(element('p', 'er-review-body', review.body));

    var meta = element('div', 'er-review-meta');
    meta.appendChild(element('span', 'er-review-author', review.reviewer));
    if (review.verified) {
      var verified = element('span', 'er-review-verified', 'Verified review');
      verified.setAttribute('aria-label', 'Verified customer review');
      meta.appendChild(verified);
    }
    if (review.productHandle) {
      var product = element('a', 'er-review-product', review.productName || 'View reviewed ring');
      product.href = '/products/' + encodeURIComponent(review.productHandle);
      product.textContent = 'Review for: ' + (review.productName || 'View reviewed ring');
      meta.appendChild(product);
    }
    card.appendChild(meta);

    if (review.reply) {
      var reply = element('div', 'er-review-reply');
      reply.appendChild(element('strong', '', 'Exclusive Rings replied:'));
      reply.appendChild(element('p', '', review.reply));
      card.appendChild(reply);
    }

    return card;
  }

  function filteredReviews() {
    var query = normalized(search.value);
    var selectedRating = parseInt(rating.value, 10) || 0;
    var reviews = data.reviews.filter(function (review) {
      if (selectedRating && review.rating !== selectedRating) return false;
      if (!query) return true;
      var haystack = normalized([
        review.title,
        review.body,
        review.reviewer,
        review.productName,
        review.reply
      ].join(' '));
      return haystack.indexOf(query) !== -1;
    });

    reviews.sort(function (a, b) {
      if (sort.value === 'oldest') return a.date.localeCompare(b.date);
      if (sort.value === 'highest') return (b.rating - a.rating) || b.date.localeCompare(a.date);
      if (sort.value === 'lowest') return (a.rating - b.rating) || b.date.localeCompare(a.date);
      return b.date.localeCompare(a.date);
    });
    return reviews;
  }

  function render(resetVisible) {
    if (resetVisible) visible = pageSize;
    var reviews = filteredReviews();
    var shown = reviews.slice(0, visible);
    var fragment = document.createDocumentFragment();
    shown.forEach(function (review) { fragment.appendChild(reviewCard(review)); });
    grid.replaceChildren(fragment);

    empty.hidden = reviews.length !== 0;
    grid.hidden = reviews.length === 0;
    loadMore.hidden = visible >= reviews.length;
    status.textContent = reviews.length
      ? 'Showing ' + shown.length.toLocaleString() + ' of ' + reviews.length.toLocaleString() + ' reviews'
      : 'No reviews match the selected filters';
  }

  var searchTimer;
  search.addEventListener('input', function () {
    window.clearTimeout(searchTimer);
    searchTimer = window.setTimeout(function () { render(true); }, 180);
  });
  rating.addEventListener('change', function () { render(true); });
  sort.addEventListener('change', function () { render(true); });
  clear.addEventListener('click', function () {
    search.value = '';
    rating.value = '0';
    sort.value = 'newest';
    render(true);
    search.focus();
  });
  loadMore.addEventListener('click', function () {
    visible += pageSize;
    render(false);
  });
  document.getElementById('erReviewsControls').addEventListener('submit', function (event) {
    event.preventDefault();
    render(true);
  });

  render(true);
}());
